module.exports = __webpack_public_path__ + "ac1bdaefa2b15d118ddc984f6067cff8.png";